<template>
  <RouterView />
  <AdBlockerDialog v-if="adBlockerSuspected" @close="dismissAdBlockerWarning" />
</template>
<script lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { mapGetters } from 'vuex'

import AdBlockerDialog from '@/components/AdBlockerDialog/AdBlockerDialog.vue'
import { config } from '@/lib/helpers'
import { useErrorNotification } from '@/lib/hooks'
import { useGlobalDateRangeSync } from '@/lib/hooks/globalDateRangeSync.hooks'
import { adBlockerSuspected, dismissAdBlockerWarning } from '@/lib/services/ad-blocker.service'
import { initializeBannedUserChannel } from '@/lib/services/banned-user.service'

export default {
  components: { AdBlockerDialog },
  setup() {
    const router = useRouter()
    useGlobalDateRangeSync()

    onMounted(() => {
      useErrorNotification()
      initializeBannedUserChannel(() => {
        void router.push({ name: 'no-access' })
      })
    })

    return { adBlockerSuspected, dismissAdBlockerWarning }
  },
  computed: {
    ...mapGetters('shop', ['shop', 'userCanEditAllInfluencers']),
  },
  watch: {
    userCanEditAllInfluencers: function (userCanEditAllInfluencers) {
      /* Only download iframe script if it can be used, is used on influencer page */
      if (userCanEditAllInfluencers) {
        const el = document.createElement('script')
        el.setAttribute('type', 'text/javascript')
        el.setAttribute('src', 'https://code.jquery.com/jquery-3.2.1.min.js')
        document.getElementsByTagName('head')[0].appendChild(el)
        el.addEventListener('load', () => {
          const el = document.createElement('script')
          el.setAttribute('type', 'text/javascript')
          el.setAttribute('src', `${config.metapicApiUrl}/javascript/iframeScript.js`)
          document.getElementsByTagName('head')[0].appendChild(el)
        })
      }
    },
  },
}
</script>
